import { render, staticRenderFns } from "./ExtSobre.vue?vue&type=template&id=1965d52c&"
import script from "./ExtSobre.vue?vue&type=script&lang=js&"
export * from "./ExtSobre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports